<template lang="html">
  <ul class="header">
    <li @click="switchTag('all')" :class="{ active: 'all' === value }">全部</li>
    <li v-for="item in tags" @click="switchTag(item.id)" :class="{ active: `${item.id}` === value }" :key="item.id">{{item.name}}</li>
  </ul>
</template>

<script>
import { get } from '../../../utils/request'
import { set } from '../../../utils/token'
export default {
  props: {
    value: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      tags: [
      ]
      // tagId: 'all'
    }
  },
  mounted () {
    this.getAllTags()
  },
  methods: {
    switchTag (tagId) {
      // this.tagId = tagId
      set('tagId', tagId)
      this.$emit('input', `${tagId}`)
    },
    getAllTags () {
      const promise = get({
        url: '/course/type'
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          this.tags = detail
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  padding: 0 3.47vw;
  width: 100%;
  overflow-x: scroll;
  box-sizing: border-box;
  overflow-y: hidden;
  white-space: nowrap;
  li {
    white-space: nowrap;
    height:20px;
    font-size:14px;
    font-family:AlibabaPuHuiTi-Regular,AlibabaPuHuiTi;
    font-weight:400;
    color:rgba(107,107,107,1);
    line-height:20px;
    margin-right: 34px;
    display: inline-block;
    padding: 0 4px;
    position: relative;
    height: 50px;
    line-height: 50px;
    &:last-child {
      margin-right: 0;
    }
  }
  .active {
    font-weight:bold;
    color:rgba(58,58,58,1);
    &::after {
      position: absolute;
      content: '';
      left: 0;
      bottom: 0;
      width: 100%;
      height:4px;
      background:rgba(24,204,159,1);
    }
  }
}

</style>
